import { jsx as _jsx } from "react/jsx-runtime";
import { AccreditationsList } from '@src/components/Admin/AccreditationsList/AccreditationsList';
import { CountrySchoolStats } from '@src/components/Admin/CountrySchoolStats/CountrySchoolStats';
import { useParams } from 'react-router-dom';
export const AdminSchools = () => {
    const { tab = 'countries' } = useParams();
    if (tab === 'accreditations') {
        return _jsx(AccreditationsList, {});
    }
    return _jsx(CountrySchoolStats, {});
};
